export default __webpack_public_path__ + "static/media/down_arrow.87272611.svg";